/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceStatItem } from './SurfaceStatItem';
import {
    SurfaceStatItemFromJSON,
    SurfaceStatItemFromJSONTyped,
    SurfaceStatItemToJSON,
    SurfaceStatItemToJSONTyped,
} from './SurfaceStatItem';

/**
 * 
 * @export
 * @interface SurfaceStatsConfig
 */
export interface SurfaceStatsConfig {
    /**
     * 
     * @type {Array<SurfaceStatItem>}
     * @memberof SurfaceStatsConfig
     */
    items?: Array<SurfaceStatItem>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStatsConfig
     */
    layout?: SurfaceStatsConfigLayoutEnum;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStatsConfig
     */
    columns?: number;
}


/**
 * @export
 */
export const SurfaceStatsConfigLayoutEnum = {
    row: 'row',
    grid: 'grid'
} as const;
export type SurfaceStatsConfigLayoutEnum = typeof SurfaceStatsConfigLayoutEnum[keyof typeof SurfaceStatsConfigLayoutEnum];


/**
 * Check if a given object implements the SurfaceStatsConfig interface.
 */
export function instanceOfSurfaceStatsConfig(value: object): value is SurfaceStatsConfig {
    return true;
}

export function SurfaceStatsConfigFromJSON(json: any): SurfaceStatsConfig {
    return SurfaceStatsConfigFromJSONTyped(json, false);
}

export function SurfaceStatsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStatsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SurfaceStatItemFromJSON)),
        'layout': json['layout'] == null ? undefined : json['layout'],
        'columns': json['columns'] == null ? undefined : json['columns'],
    };
}

export function SurfaceStatsConfigToJSON(json: any): SurfaceStatsConfig {
    return SurfaceStatsConfigToJSONTyped(json, false);
}

export function SurfaceStatsConfigToJSONTyped(value?: SurfaceStatsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SurfaceStatItemToJSON)),
        'layout': value['layout'],
        'columns': value['columns'],
    };
}

